import React, { useEffect, useState } from "react";
// import Header from './../components/Header';
import { Container, Row, Col, FormGroup, Label, Input } from "reactstrap";
import ReactTooltip from "react-tooltip";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { searchTransactions } from "./../../stores/services/transactions.service";
import { getFundByAmc } from "./../../stores/services/funds.service";
import ViewTransaction from "./../view-beta-txn";
import { toast } from "react-toastify";
import { BsTable } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { numberWithCommas } from "../../utils/customFunction";
import { newTXNType } from "../../utils/ui_data";
import TransactionTable from "../TransactionListing/TransactionTable";

const AdjustmentTransactions = () => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  const email = sessionStorage.getItem("email") || "";
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const history = useHistory();
  let [transactions, setTransactions] = useState<any>([]);
  let [status, setStatus] = useState("");
  const [trx_history, setTrxHistory] = useState([]);
  const [viewChecklist, setViewCheckList] = useState(false);
  const [trx_checklist, setTrxCheckList] = useState([]);
  // let [lastPageNum, setLastPageNum] = useState('');
  let [paginationArr, setPaginationArr] = useState([""]);
  let [currentPage, setCurrentPage] = useState("");
  let [activePage, setActivePage] = useState("");

  const [searchLoading, setSearchLoading] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [resLoading, setResLoading] = useState(false);

  const [allFunds, setAllFunds] = useState<any>([]);
  const [fund, setFund] = useState("");

  const [togglePagination, setTogglePagination] = useState(false);

  React.useEffect(() => {
    //     async function getTransactions(){
    //       if(togglePagination!=true){
    //       setResLoading(true);
    //     await getAllPendingTransactions(
    //       sessionStorage.getItem('email') || '',
    //       status,
    //       searchValue,
    //       '',
    //       activePage
    //     )
    //       .then((response) => {
    //         let pageArr = paginationArr;
    //         let existingPageIndex = paginationArr.findIndex(
    //           (x) => x === response.data.page_info.next_page_number
    //         );
    //         if (
    //           existingPageIndex === -1 &&
    //           response.data.data.length === 10
    //           // &&
    //           // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
    //         ) {
    //           pageArr.push(response.data.page_info.next_page_number);
    //         }
    //         setPaginationArr(pageArr);
    //         setTransactions(response.data.data);
    //         setResLoading(false);
    //       })
    //       .catch((err) => {
    //         setResLoading(false);
    //       });
    //       setResLoading(false);
    //     }else{
    //       if(searchValue!==''){
    //         searchValue='TXN_'+searchValue;
    //       }
    //       setResLoading(true);
    //       await searchTransactions(
    //         sessionStorage.getItem('email') || '',
    //           amc_code,
    //           fund,
    //           status === '-1' ? '' : status,
    //           searchValue,
    //           activePage
    //       )
    //         .then((response) => {

    //           if(response.data.data.length>0){
    //             let pageArr = paginationArr
    //             let existingPageIndex = paginationArr.findIndex(
    //               (x) => x === response.data.page_info.next_page_number
    //             );
    //             if (
    //               existingPageIndex === -1 &&
    //               response.data.data.length === 10
    //               // &&
    //               // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
    //             ) {
    //               pageArr.push(response.data.page_info.next_page_number);
    //             }
    //             setPaginationArr(pageArr);
    //             setTransactions(response.data.data);
    //           }else{
    //             setTransactions([]);
    //           }
    //           setResLoading(false);

    //         })
    //         .catch((err) => {
    //           setResLoading(false);
    //         });
    //         setResLoading(false);
    //     }
    //   }
    activePage
      ? searchTransactionsByAMCAndFund("", "", "", "", "")
      : searchTransactionsByAMCAndFund("", "", "", "", "true");
  }, [activePage]);

  const getFunds = async () => {
    try {
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (error) { }
  };

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  React.useEffect(() => {
    getFunds();
    searchTransactionsByAMCAndFund("", "", "", "", "true");
  }, [fund_code]);

  // useEffect(() => {

  //   getFunds();
  // }, []);

  // Fund Type Drop Down
  // const renderFundsDropDown = () => {
  //   return allFunds.map((item: any, index) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // };

  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  const searchTransactionsByAMCAndFund = async (
    statusVar = "",
    searchVar = "",
    amcCodeVar = "",
    fundCodeVar = "",
    resetData = ""
  ) => {
    setTogglePagination(true);
    return new Promise(async (resolve, reject) => {
      if (searchVar !== "") {
        searchVar = "TXN_" + searchVar;
      }
      if (activePage !== "") {
        setBtnLoading(true)
      }
      else {
        setResLoading(true);
      }
      setSearchLoading(true);
      await searchTransactions(
        sessionStorage.getItem("email") || "",
        amc_code,
        fundCodeVar ? fundCodeVar : fund_code?.length > 0 ? fund_code : "",
        "COMPLETED",
        searchVar,
        activePage
      )
        .then((response) => {
          if (response.data.data.length > 0) {
            // let pageArr = paginationArr

            //     paginationArr = paginationArr.filter(function(item) {
            //       return item == ''
            //   })
            let pageArr = paginationArr;
            let existingPageIndex = paginationArr.findIndex(
              (x) => x === response.data.page_info.next_page_number
            );
            if (
              existingPageIndex === -1 &&
              response.data.data.length === 10
              // &&
              // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
            ) {
              pageArr.push(response.data.page_info.next_page_number);
            }
            setHasNextPage(response?.data?.page_info?.hasNextPage || false);
            setPaginationArr(pageArr);
            // setTransactions(response.data.data);
            setTransactions(
              resetData == "true"
                ? [...response.data.data]
                : [...transactions, ...response.data.data]
            );
          } else {
            setHasNextPage(false);
            setTransactions([]);
          }
          setResLoading(false);
          setBtnLoading(false);
          setSearchLoading(false);

          resolve("Success");
        })
        .catch((err) => {
          setHasNextPage(false);
          setResLoading(false);
          setBtnLoading(false);
          setSearchLoading(false);
          reject("Error");
        });
      setResLoading(false);
      setBtnLoading(false);
      setSearchLoading(false);
    });
  };

  const clearFilters = async (
    statusVar = undefined as any,
    searchVar = undefined as any,
    pageNumber: string = ""
  ) => {
    return new Promise(async (resolve, reject) => {
      // setLoading(true);
      setResLoading(true);
      setClearLoading(true);
      await searchTransactions(
        sessionStorage.getItem("email") || "",
        amc_code,
        fund_code?.length > 0 ? fund_code : "", // fund code
        "COMPLETED",
        "", // txn id
        activePage
      )
        .then((response) => {
          let pageArr = paginationArr;
          let existingPageIndex = paginationArr.findIndex(
            (x) => x === response.data.page_info.next_page_number
          );
          if (
            existingPageIndex === -1 &&
            response.data.data.length === 10
            // &&
            // 10 * pageArr.length !==	parseInt(response.data.page_info.total_count)
          ) {
            pageArr.push(response.data.page_info.next_page_number);
          }
          setHasNextPage(response?.data?.page_info?.hasNextPage || false);
          setPaginationArr(pageArr);
          setTransactions(response.data.data);
          setResLoading(false);
          setClearLoading(false);
          resolve("Success");
          setTogglePagination(false); // false search pagination.
        })
        .catch((err) => {
          setHasNextPage(false);
          setResLoading(false);
          setClearLoading(false);
          if (err.response !== undefined) {
            toast.error(err.response.data.message);
          } else {
            toast.error("Request Failed!");
          }
          reject("Error");
        });
      setResLoading(false);
      setClearLoading(false);
    });
  };

  // const numberWithCommas = (amount: any) => {
  //   return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // };

  // const [Loading, setLoading] = useState(false);
  const [view, setView] = useState(false);
  const [data, setData] = useState<any>([]);

  const [note, setNote] = useState("");

  let [searchValue, setSearchValue] = useState("");

  // let txnTypes = JSON.parse(sessionStorage.getItem('txnType') || '');
  let txnTypes = useSelector((state: any) => state.txnTypes);
  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };

  const [viewTxnModal, setViewTxnModal] = useState(false);
  const renderViewTxnModalPopup = () => {
    switch (viewTxnModal) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="xl"
            backdrop={true}
            onHide={() => {
              setViewTxnModal(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setViewTxnModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">View Transaction </h6>
            </div>
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setViewTxnModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up"></h6>
            </div>
            <div className="modal-body">
              <div className="">
                <h4 className="card-title">
                  <i
                    className="fa fa-angle-left mr-2 pointer"
                    onClick={() => {
                      setView(false);
                    }}
                  ></i>
                  View Transaction
                </h4>
                <ViewTransaction data={data} />

                <div className="line"></div>

                <Row className=" pb-5">
                  {trx_history.map((hist: any, index: number) => {
                    return (
                      <Col
                        md="3"
                        onClick={() => {
                          if (hist.action === "REJECTED-AMC") {
                            setNote(hist.note);
                          } else {
                            setNote("");
                          }
                          if (hist.action === "CREATED") {
                            return;
                          }
                          if (!hist.check_list) return;
                          setTrxCheckList(hist.check_list);
                          setViewCheckList(true);
                        }}
                      >
                        <div className="card process-card pointer">
                          <div className="card-header">
                            <h4 className="card-title">
                              <i className="tim-icons icon-single-02 mr-1"></i>{" "}
                              <span className="card-number">{index + 1}</span>
                              {hist.updated_by_role}{" "}
                            </h4>
                          </div>
                          <div className="card-body text-center">
                            <p className="small mt-2">Status:</p>
                            <h3 className="accepted text-primary">
                              {" "}
                              {hist.action}{" "}
                            </h3>
                            {hist.updated_at !== "" ? (
                              <>
                                <p className="small mt-2">by</p>
                                <h4 className="comment text-primary">
                                  {hist.updated_by}
                                </h4>
                                <p className="small mt-2">at</p>
                                <h4 className="comment text-primary">
                                  {moment(hist.updated_at).format(
                                    "DD-MM-YYYY, h:mm a"
                                  )}
                                </h4>
                              </>
                            ) : (
                              ""
                            )}
                            {hist.note !== "" ? (
                              <>
                                <p className="small mt-2">Comment</p>
                                <small
                                  className="comment dot-text"
                                  title={hist.note}
                                >
                                  {hist.note}
                                </small>
                              </>
                            ) : (
                              ""
                            )}
                            {hist.created_by !== "" ? (
                              <>
                                <p className="small mt-2">by</p>
                                <h4 className="text-primary">
                                  {hist.created_by}
                                </h4>
                                <p className="small mt-2"> at</p>
                                <h4 className="comment text-primary">
                                  {" "}
                                  {moment(hist.created_at).format(
                                    "DD-MM-YYYY, h:mm a"
                                  )}{" "}
                                </h4>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund =
      allFunds && allFunds?.find((item) => item?.symbol_code === fund);
    return selectedFund
      ? {
        value: selectedFund.symbol_code,
        label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
      }
      : null;
  }, [allFunds, fund]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <div className="card ">
                <div className="card-header">
                  <h4 className="card-title text-primary">Adjustment</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <ReactTooltip
                        textColor="white"
                        backgroundColor="black"
                        effect="float"
                      />
                      <div className="form-group">
                        <label>Transaction ID</label>
                        <input
                          style={{
                            paddingTop: "6px",
                            paddingBottom: "6px",
                          }}
                          type="search"
                          id="myInput"
                          placeholder="Transaction Id"
                          data-tip="Search Transaction"
                          className="form-control"
                          value={searchValue}
                          onChange={(e) => {
                            setSearchValue(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group ml-2 mr-2">
                        <label>Select Fund</label>
                        <Select
                          value={selectedFundName}
                          label={"Select Fund"}
                          onChange={(e) => {
                            setFund(e?.value);
                          }}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll={true}
                          isClearable={true}
                          isSearchable={true}
                          name="color"
                          options={renderFundsDropDown()}
                          styles={customStyles}
                        />
                        {/* <select
                          className={"form-control"}
                          value={fund}
                          onChange={(e) => {
                            setFund(e.target.value);
                          }}
                        >
                          <option value="" defaultChecked hidden>
                            Select Fund
                          </option>
                          {renderFundsDropDown()}
                        </select> */}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className=" inline-box">
                        <button
                          className="btn btn-primary mt-4 ml-2"
                          disabled={Boolean(searchLoading)}
                          onClick={() => {
                            if (
                              (searchValue || status !== "-1" || fund) !== ""
                            ) {
                              searchTransactionsByAMCAndFund(
                                status,
                                searchValue,
                                "",
                                fund,
                                "true"
                              ).then(() => {
                                // setActivePage("");
                              });
                            }
                          }}
                        >
                          {searchLoading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Searching...</span>
                            </>
                          ) : (
                            "Search"
                          )}
                        </button>

                        <button
                          className="btn btn-default ml-2 mt-4 ml-2"
                          disabled={Boolean(clearLoading)}
                          style={{
                            width: "148px",
                          }}
                          onClick={() => {
                            clearFilters("", "").then(() => {
                              setStatus("-1");
                              setSearchValue("");
                              setActivePage("");
                              setFund("");
                            });
                          }}
                        >
                          {clearLoading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Clear</span>
                            </>
                          ) : (
                            "Clear"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>


                  <div className="">
                    {resLoading ? (
                      <div className="d-flex justify-content-center my-5">
                        <i
                          className="fa fa-spinner fa-spin fa-3x"
                          aria-hidden="true"
                        ></i>
                      </div>
                    ) : transactions.length > 0 ? (
                      <TransactionTable
                        transactions={transactions}
                        CapTxnType={CapTxnType}
                        historyPath={`/admin/adjustment-txn`}
                        type={`adjTxn`}
                      />
                      // <div className="table-responsive">
                      //   <table className="table mt-2">
                      //     <thead>
                      //       <tr>
                      //         <th>Date</th>
                      //         <th>Transaction</th>
                      //         <th>Fund</th>
                      //         <th>Investor</th>
                      //         <th>Amount</th>
                      //         <th>Bank</th>
                      //         {/* <th>Counter Acc</th> */}
                      //         {/* <th>Instrument</th> */}
                      //         <th>Created</th>
                      //         <th>Status</th>
                      //         <th>Act</th>
                      //       </tr>
                      //     </thead>
                      //     <tbody>
                      //       {transactions.map(
                      //         (transaction: any, index: number) => {

                      //           return (
                      //             <tr key={index}>
                      //               <td>
                      //                 {moment(
                      //                   transaction.execution_date
                      //                 ).format("DD-MM-YYYY")}
                      //                 <br />
                      //                 <span className="sub-content">
                      //                   Entry{" "}
                      //                   {moment(
                      //                     transaction.instruction_date
                      //                   ).format("DD-MM-YYYY")}{" "}
                      //                 </span>
                      //               </td>

                      //               <td>
                      //                 {transaction.txn_title ? transaction.txn_title :
                      //                   newTXNType?.find((ele) => ele?.value == transaction?.txnr_type) ?
                      //                     newTXNType?.find((ele) => ele?.value == transaction?.txnr_type)?.label :
                      //                     transaction.txnr_type
                      //                       ? `${CapTxnType(
                      //                         transaction.txnr_type
                      //                       )}	${transaction.detail?.includes(
                      //                         "Reversed"
                      //                       )
                      //                         ? " (Reversed)"
                      //                         : ""
                      //                       }`
                      //                       : "N/A"}
                      //                 <br />{" "}
                      //                 <span className="sub-content">
                      //                   {transaction.txn_id.replace("TXN_", "")}
                      //                 </span>
                      //               </td>

                      //               <td>
                      //                 {transaction.fund_code}
                      //                 <br />{" "}
                      //                 <span className="sub-content">
                      //                   NAV{" "} {transaction?.nav || 0}
                      //                 </span>
                      //               </td>

                      //               <td>
                      //                 {transaction.folio_no?.replace(`${transaction?.amc_code}-`, "")}
                      //                 <br />{" "}
                      //                 <span
                      //                   className="sub-content">
                      //                   {
                      //                     transaction?.unitholder_name?.length > 10 ?
                      //                       transaction?.unitholder_name?.slice(0, 10) + "..." :
                      //                       transaction?.unitholder_name
                      //                   }
                      //                 </span>
                      //               </td>

                      //               <td className="text-left pr-3">
                      //                 {numberWithCommas(
                      //                   transaction.net_amount > 0
                      //                     ? parseFloat(
                      //                       transaction.net_amount
                      //                     )?.toFixed(4)
                      //                     : 0
                      //                 )}{" "}
                      //                 <br />
                      //                 <span className="sub-content">
                      //                   {numberWithCommas(
                      //                     transaction.gross_amount > 0
                      //                       ? parseFloat(
                      //                         transaction.gross_amount
                      //                       )?.toFixed(4)
                      //                       : 0
                      //                   )}
                      //                 </span>
                      //               </td>

                      //               <td>
                      //                 {transaction?.bank ? transaction?.bank : transaction?.counter_bank}
                      //                 <br />
                      //                 <span className="sub-content">
                      //                   {transaction?.account_number ? transaction?.account_number : transaction?.counter_account_number}
                      //                 </span>
                      //               </td>

                      //               {/* <td>
                      //                 {transaction.counter_bank} <br />
                      //                 <span className="sub-content">
                      //                   {transaction.counter_account_number}
                      //                 </span>
                      //               </td> */}

                      //               {/* <td>
                      //                 {transaction.mode_of_payment} <br />
                      //                 <span className="sub-content">
                      //                   {transaction.instrument_type}{" "}
                      //                   {transaction.instrument_no !== ""
                      //                     ? transaction.instrument_no + ","
                      //                     : ""}{" "}
                      //                   {moment(
                      //                     transaction.instrument_date
                      //                   ).format("DD-MM-YYYY")}
                      //                 </span>
                      //               </td> */}

                      //               <td>
                      //                 {moment(transaction.created_at).format(
                      //                   "DD-MM-YYYY"
                      //                 )}{" "}
                      //                 <br />
                      //                 <span className="sub-content">
                      //                   {transaction.created_by.split("@")[0]}
                      //                 </span>
                      //               </td>
                      //               <td>
                      //                 <span
                      //                   style={{
                      //                     color: transaction?.txn_status == "COMPLETED" ? "green" : ""
                      //                   }}
                      //                 >
                      //                   {transaction?.txn_status}
                      //                 </span>
                      //                 <br />
                      //                 <span className="sub-content">
                      //                   {transaction?.txn_history[transaction?.txn_history?.length - 1]?.created_at !== "" && transaction?.txn_history[transaction?.txn_history?.length - 1]?.action == "CREATED" ?
                      //                     moment(transaction?.txn_history[transaction?.txn_history?.length - 1]?.created_at).format(
                      //                       "DD-MM-YYYY"
                      //                     ) || "" :
                      //                     moment(transaction?.txn_history[transaction?.txn_history?.length - 1]?.updated_at || transaction?.txn_history[transaction?.txn_history?.length - 1]?.created_at).format(
                      //                       "DD-MM-YYYY"
                      //                     ) || ""
                      //                   }
                      //                 </span>
                      //               </td>
                      //               <td className=" ">
                      //                 <div className="multi-icons pointer">
                      //                   <button
                      //                     type="button"
                      //                     className="btn-icon btn-link like btn btn-info btn-sm"
                      //                     onClick={() => {
                      //                       sessionStorage.setItem(
                      //                         "adjTxn",
                      //                         JSON.stringify(transaction)
                      //                       );
                      //                       history.replace(
                      //                         `/admin/adjustment-txn`
                      //                       );
                      //                     }}
                      //                   >
                      //                     <i className="fa fa-eye"></i>
                      //                   </button>
                      //                 </div>
                      //               </td>
                      //             </tr>
                      //           );
                      //         }
                      //       )}
                      //     </tbody>
                      //   </table>
                      // </div>
                    ) : (
                      <div className="table-empty">
                        <BsTable className="icon" />
                        <p className="text-center empty-text">
                          No record found
                        </p>
                      </div>
                    )}

                    <div className="row justify-content-center">
                      {hasNextPage ?
                        <button
                          aria-hidden={true}
                          className="btn btn-sm mt-2 py-2 px-3 pointer"
                          disabled={!hasNextPage ||
                            resLoading || btnLoading
                          }
                          type="button"
                          onClick={() => {
                            let pageNowIs = Number(activePage == "" ? "1" : activePage) + 1
                            setActivePage(pageNowIs?.toString())
                          }}
                        >
                          {resLoading || btnLoading ? (
                            <span>
                              Loading...{" "}
                              <i
                                className="fa fa-spinner fa-spin  "
                                aria-hidden="true"
                              ></i>
                            </span>
                          ) : (
                            "Show More"
                          )}
                        </button> :
                        (transactions.length > 20 && !hasNextPage) ? <span className="my-2">No More Record To Show</span> : ""
                      }
                    </div>
                  </div>
                </div>
              </div>
              {renderViewTxnModalPopup()}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default AdjustmentTransactions;
